import React from 'react';
import { faFont } from '@fortawesome/pro-regular-svg-icons';
import ToolBarColorPicker from 'components/actionBar/components/ToolbarColorPicker';
import Switch from 'components/common/Switch';
import EventFields from 'components/actionBar/ActionBarCalendar/components/EventFields';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const EventTextSection = ({ calendar, onChange }) => {
  return (
    <SettingsSection title="Event text">
      <EventFields shape={calendar} onChange={onChange} className={c.typographyFields} />
      <div className={c.optionalColourSetting}>
        <Switch
          id="calendar-weekend-event-colour"
          checked={calendar.useWeekendEventColor === true}
          onChange={() => onChange({ useWeekendEventColor: calendar.useWeekendEventColor !== true })}
          label="Weekend event colour"
        />
        {calendar.useWeekendEventColor === true ? (
          <ToolBarColorPicker
            initialValue={calendar.weekendEventColor || calendar.eventStyle?.fill || calendar.mainColor}
            onChange={(weekendEventColor) => onChange({ weekendEventColor })}
            icon={faFont}
          />
        ) : null}
      </div>
      <label className={c.field}>
        <span>Spacing below date number</span>
        <input
          type="number"
          min="0"
          step="any"
          value={calendar.eventDateSpacing ?? 0}
          onChange={(event) => {
            const value = Number(event.target.value);
            onChange({ eventDateSpacing: Number.isFinite(value) ? Math.max(0, value) : 0 });
          }}
        />
      </label>
    </SettingsSection>
  );
};

export default EventTextSection;
